import axios from "axios";
import { apiInstance } from "./API";
import { ensureFreshToken, getStoredAccessToken } from "./tokenManager";

/**
 * Sends a request through the shared axios instance. Unlike the generic `apiCall` helpers, the full
 * response (headers such as X-Pagination included) is returned, HTTP failures reject instead of resolving with
 * a parsed error, and an AbortSignal can be supplied to cancel a request that is no longer needed.
 */
export function abortableRequest({ method = "get", url, data, signal }) {
  ensureFreshToken().catch(() => {});
  const token = getStoredAccessToken();

  return apiInstance.request({
    method,
    url,
    data,
    signal,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}

/** True when the error comes from an aborted request rather than a failed one. */
export const isRequestCanceled = (error) => axios.isCancel(error);
